import titleLogo from "asset/mobile_web/img/icon/filled/developer-board.svg";
import deviceLogo from "asset/mobile_web/img/device.png"
import cameraImg from "asset/mobile_web/img/icon/filled/icon-btn/camera-alt.svg"
import coinImg from "asset/mobile_web/img/icon/filled/icon-btn/style.svg"
import prgmImg from "asset/mobile_web/img/icon/filled/icon-btn/blur-on.svg"
import offImg from "asset/mobile_web/img/icon/filled/icon-btn/free-icon-on-off-button-1228.png"

import printV from "asset/img/icon/filled/icon-btn/print_v.png"
import printH from "asset/img/icon/filled/icon-btn/print_h.png"

import styled from "styled-components";
import ButtonUtil from "components/mobile/UI/ButtonUtil";
import { Accordion } from "react-bootstrap";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import CmmnRadio from "components/mobile/cmmn/CmmnRadio";
import connectFailImg from "asset/photomag_web/img/연결실패.png";
import receiveScreen from "asset/img/receive_screen.png";
import { useCallback, useEffect, useState } from "react";
import CmmnAccordionItem from "components/mobile/cmmn/CmmnAccordionItem";
import moment from "moment";
import { callApi } from "util/HttpService";
import CmmnRestartIcon from "components/mobile/cmmn/CmmnRestartIcon";
import { alert, modalConfirm } from "components/web/cmmn/CmmnConfirm";
import InputBox from "components/mobile/UI/InputBox";
import { useWindowSize } from "context/WindowSizeContext";
import { useTranslation } from "react-i18next";
import { useBrch } from "components/web/auth/BrchProvider";
import CmmnMbSysCnfModal from "components/mobile/cmmn/CmmnMbSysCnfModal";
import NetStatusImg from "../dsh-brd/component/NetStatusImg";
import CmmnTestPrintIcon from "components/mobile/cmmn/CmmnTestPrintIcon";

const DvcBoxWrap = styled.div`
    margin-top: 20px;
    .dashboard-box {
        background-color: #fff;
        border-radius: 16px;
        width: 100%;
        margin-bottom: 20px;
        box-shadow: 0 0 10px rgba(0,0,0,.1);
    }
    .mt-30 {
        margin-top: 30px;
    }
    .w-10 {
        width: 10%;
    }
`;
const MenuTitleWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    // padding: 20px;
    padding: 10px 20px 0px 20px;
    border-bottom: 1px solid #EEEEEE;
    width: 100%;
    border: none !important;
    padding-bottom: 0 !important;
    h3 {
        font-size: 16px;
        color: ${({ theme }) => theme.colors.dark2};
        font-weight: 500;
    }
    h5 {
        font-size: 14px;
        color: ${({ theme }) => theme.colors.gray6};
        font-weight: 400;
    }
`;
const DeviceMtr = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 15px;
    // padding: 20px;
    padding: 10px 20px 20px 20px;
    margin: 0 !important;
    .device-img {
        width: 75%;
        border-radius: 16px;
        position: relative;
        // background-image: url(${deviceLogo});
        background-position: center;
        background-size: cover;
        height: 150px;
        padding: 10px;
        border: 1px solid #EEEEEE;
        width: 100%;
        .device-status {
            display:flex;
            justify-content:space-between;
        }
        .state-box {
            padding: 5px 10px;
            color: #fff;
            font-size: 14px;
            border-radius: 100px;
            width: fit-content;
            background-color: ${({ theme }) => theme.colors.green};
        }
        .use {
            background-color: #00d45e;
        }
        .wating {
            background-color: #1f93ed;
        }
        .connect-fail {
            background-color: ${({ theme }) => theme.colors.gray8};
        }
    }
`;
const CustomAccordion = styled.div`
    .accordion-item {
        margin-bottom: 10px !important;
        border-radius: 8px;
        border: none !important;
        box-shadow: 0 0 10px rgba(0,0,0,.1);
        .accordion-button {
            font-size: 16px;            
            font-weight: 500;
            border-radius: 8px !important;
            box-shadow: none !important;
            &:not(.collapsed) {
                background-color: #5a7bbf !important;
                // background-color: ${({ theme }) => theme.colors.red};
                // background-color: #3c5fa1 !important;
                color: #fff !important;
                &::after {
                    color: #fff !important;
                    filter: brightness(0) invert(1); /* 흰색으로 변환 */
                }
            }
        }
        .accordion-body {
            // border-top: 1px solid #eeeeee;
            padding: 20px;
        }
    }
`;
const InfoList = styled.ul`
    li {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
        &:last-child {
            margin-bottom: 0;
        }
        h2 {
            font-size: 16px;
            color: ${({ theme }) => theme.colors.dark2};
            font-weight: 500;
            line-height: 150%;
            width: 50%;
        }
        h3 {
            font-size: 16px;
            color: ${({ theme }) => theme.colors.dark2};
            font-weight: 400;
            line-height: 150%;
            width: 50%;
            text-align: left;
        }
    }
`;
const PlusMinusBtnWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;
    .circle-icon-btn {
        padding: 15px;
        border-radius: 100px;
        background-color: #fff;
        border: 1.5px solid ${({ theme }) => theme.colors.red};
        transition: all .3s ease-in-out;
        &:hover {
            background-color: ${({ theme }) => theme.colors.red};
        }
        &:hover svg {
            color: #fff;
        }
        svg {
            font-size: 18px;
            color: ${({ theme }) => theme.colors.red};
        }
    }
    .plus-minus-input {
        margin: 0 10px;
        input {
            text-align: center;
        }
        .input_box:last-of-type {
            margin: 0 !important;
        }
    }
`;
const SmallBtnWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;
    .btn {
        font-size: 14px;
        padding: 7px 20px;
        // width: 49%;
        width: 100%;
        &:hover {
            color: var(--bs-btn-hover-color) !important;
            background-color: var(--bs-btn-hover-bg) !important;
            border-color: var(--bs-btn-hover-border-color) !important;
        }
    }
`;
const POLLING_INTERVAL = 10000;
export default function DvcMgt() {

    library.add(faPlus, faMinus);
    const { t } = useTranslation();
    const isMobile = useWindowSize();
    const { brchId, getBrchCrdInfo, crdInfo } = useBrch();    
    const [pntCalcVal,setPntCalcVal] = useState(0);
    const [defaultPntVal,setDefaultPntVal] = useState(0);
    const brchClsfCd = localStorage.getItem("brchClsfCd");
    const defaultSearchData = {
        brchId: brchId,
        eqmtId: "",
        issuPnt: 500, //발급 포인트
        issuQty: 0, //발급 수량
        frcgPtgyClsfCd: "", //무료촬영구분코드
    }
    const pointFreeArr = [
        { label: t("m_deviceMgtPage.pnt"), value: "PNT" },
        { label: t("m_deviceMgtPage.free"), value: "QTY" },
    ];
    const controlArr = [
        { label: t("m_deviceMgtPage.camera"), value: "CAMERA", img: cameraImg },
        { label: t("m_deviceMgtPage.paymentMachine"), value: "COIND", img: coinImg },
        { label: t("m_deviceMgtPage.program"), value: "PRGM", img: prgmImg },
        { label: t("m_deviceMgtPage.program"), value: "OFF", img: offImg },
    ];
    const testPrintArr = [
        { label: t("m_deviceMgtPage.lblVerticalPrint"), value: "V", img: printV },
        { label: t("m_deviceMgtPage.lblHorizontalPrint"), value: "H", img: printH },        
    ];
    const [dvcList, setDvcList] = useState([]);
    const [searchData, setSearchData] = useState(defaultSearchData);
    const [applyingDevices, setApplyingDevices] = useState({});
    const [applyingResetDevices, setApplyingResetDevices] = useState({});

    const [sysModalOpen, setSysModalOpen] = useState(false);
    const [sysModalData, setSysModalData] = useState(null);
    const openMbSysModal = (data) => {
        setSysModalOpen(true);
        setSysModalData(data);
        lockScroll();
    };
    const closeMbSysModal = () => {
        setSysModalOpen(false);
        openScroll();
    }
    const lockScroll = useCallback(() => {
        document.body.style.cssText = `
                position: fixed;
                top: -${window.scrollY}px;
                overflow-y: scroll;
                width: 100%;
            `;
    }, []);
    const openScroll = useCallback(() => {
        const scrollY = document.body.style.top;
        document.body.style.cssText = '';
        window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
    }, []);

    const getDvcList = () => {
        const now = moment();
        callApi("GET", { brchId: brchId }, "/web/api/dvc-mgt/edm/list")
            .then(res => {
                console.log(now.format("HH:mm:ss") + " 장치 재랜더링");
                setDvcList(prevList => {
                    const updatedList = res.map(dvc => {
                        const chngDttm = moment(dvc.chngDttm+'Z');
                        const isConnectionFailed = now.diff(chngDttm, 'seconds') > 30;
                        const isReceivingScreen = now.diff(chngDttm, 'seconds') > 60;
                        // console.log("eqmtId:", dvc.eqmtId, "isConnectionFail:", isConnectionFailed);

                        // 네트워크 상태 체크
                        if(dvc.netChngDttm){
                            const netChngDttm = moment(dvc.netChngDttm+'Z');
                            const netDiffMillSec = now.diff(netChngDttm,'seconds',true);
                            if( netDiffMillSec <= 120 ){
                                if( dvc.netFailCnt === 0 ){
                                    dvc.netStatCd = "netOn";
                                }else if( dvc.netFailCnt >= 1 && dvc.netFailCnt < 10 ){
                                    dvc.netStatCd = "netWait";
                                }else if ( dvc.netFailCnt >= 10 ) {
                                    dvc.netStatCd = "netWait2";
                                }
                            }else{
                                dvc.netStatCd = "netOff";
                            }
                        }

                        const prevDvc = prevList.find(prevDvc => prevDvc.eqmtId === dvc.eqmtId) || {};

                        // if (dvc.slblPnt === 0 && dvc.slblFrcgPtgyQty === 0) {
                        //     setApplyingDevices(prev => ({ ...prev, [dvc.eqmtId]: false }));
                        // }

                        // applyingDevices === true면 비활성화 false면 활성화
                        const shouldDisableApplying =
                            dvc.prgmStatCd !== "WAITING" ||
                            dvc.slblPnt > 0 ||
                            dvc.slblFrcgPtgyQty > 0 ||
                            isConnectionFailed ||
                            isReceivingScreen;
                        const sholudDisableApplyingReset =
                            dvc.prgmStatCd !== "WAITING" ||
                            isConnectionFailed ||
                            isReceivingScreen;

                        setApplyingDevices(prev => ({ ...prev, [dvc.eqmtId]: shouldDisableApplying }));
                        setApplyingResetDevices(prev => ({ ...prev, [dvc.eqmtId]: sholudDisableApplyingReset}))
                        
                        return {
                            ...dvc,
                            pntSelected: prevDvc.pntSelected || 'PNT',
                            pnt: prevDvc.pnt || defaultPntVal,
                            qty: prevDvc.qty || 2,
                            isConnectionFailed: isConnectionFailed,
                            isReceivingScreen: isReceivingScreen,
                        };
                    });
                    // console.log(updatedList);
                    return updatedList;
                });
            })
            .catch(error => {
                console.log(error);
            });
    };
    useEffect(() => {
        getBrchCrdInfo();
        getDvcList();
        const interval = setInterval(getDvcList, POLLING_INTERVAL);
        return () => clearInterval(interval);
    }, []);

    useEffect(()=>{
        console.log('useEffect crdInfo : ',crdInfo);
        if(crdInfo){
            setDefaultPntVal(
                crdInfo.natnCd === "JP"?500
                :crdInfo.natnCd === "AU"?10:5000
            );
            setPntCalcVal(
                crdInfo.natnCd === "JP"?100
                :crdInfo.natnCd === "AU"?5:1000
            );
        }
        
    },[crdInfo]);

    const handlePntDataChange = (e, idx) => {
        const { value } = e.target;
        setDvcList(prevList => {
            const newList = [...prevList];
            newList[idx] = {
                ...newList[idx],
                pntSelected: value,
                pnt: value === "PNT" ? defaultPntVal : newList[idx].pnt,
                qty: value === "PNT" ? 2 : newList[idx].qty,
            };
            return newList;
        });
        setSearchData((prevData) => ({
            ...prevData,
            issuPnt: value === "PNT" ? defaultPntVal : 0,
            issuQty: value === "PNT" ? 0 : 2
        }));
    };

    const handleIncrease = (idx) => {
        setDvcList(prevList => {
            return prevList.map((item, index) => {
                if (index !== idx) return item;
                const updateItme = {
                    ...item,
                    pnt: item.pntSelected === "PNT" ? item.pnt + pntCalcVal : item.pnt,
                    qty: item.pntSelected === "PNT" ? item.qty : Math.min(item.qty + 2, 10)
                }
                setSearchData((prevData) => ({
                    ...prevData,
                    issuPnt: updateItme.pntSelected === "PNT" ? updateItme.pnt : prevData.issuPnt,
                    issuQty: updateItme.pntSelected === "PNT" ? prevData.issuQty : updateItme.qty
                }));
                return updateItme;
            });
        });
    };

    const handleDecrease = (idx) => {
        setDvcList(prevList => {
            return prevList.map((item, index) => {
                if (index !== idx) return item;
                const updateItme = {
                    ...item,
                    pnt: item.pntSelected === "PNT" ? Math.max(item.pnt - pntCalcVal, pntCalcVal) : item.pnt,
                    qty: item.pntSelected === "PNT" ? item.qty : Math.max(item.qty - 2, 2)
                }
                setSearchData((prevData) => ({
                    ...prevData,
                    issuPnt: updateItme.pntSelected === "PNT" ? updateItme.pnt : prevData.issuPnt,
                    issuQty: updateItme.pntSelected === "PNT" ? prevData.issuQty : updateItme.qty
                }));
                return updateItme;
            })
        })
    };

    const handleCmmnBtnClick = (btnNm, dvc, controlDeviceClsfCd) => {
        const searchParam = { ...searchData, eqmtNo: dvc.eqmtNo, frcgPtgyClsfCd: dvc.pntSelected };
        // const restartParam = { ...restartData, eqmtNo: dvc.eqmtNo, controlDeviceClsfCd: controlDeviceClsfCd };

        // if (applyingDevices[dvc.eqmtId]) {
        //     alert("", "아직 실행중입니다.", () => { return; });
        // }
        // setApplyingDevices(prev => ({ ...prev, [dvc.eqmtId]: true }));
        switch (btnNm) {
            case "cmmnInsertBtn":
                // setApplyingDevices(prev => ({ ...prev, [dvc.eqmtId]: true }));
                if (searchParam.frcgPtgyClsfCd === "PNT") {
                    callApi("POST", searchParam, "/web/api/dvc-mgt/edm/pnt-update")
                        .then(res => {
                            alert("", t("m_alert.pntInsert"), () => { getDvcList() });
                        })
                        .catch(error => {
                            alert("", t("m_alert.pntInsertError"), () => { });
                        })
                } else {
                    callApi("POST", searchParam, "/web/api/dvc-mgt/edm/pnt-update")
                        .then(res => {
                            alert("", t("m_alert.qtyInsert"), () => { getDvcList() });
                        })
                        .catch(error => {
                            alert("", t("m_alert.qtyInsertError"), () => { });
                        })
                }
                break;
            case "cmmnResetBtn":
                if (searchParam.frcgPtgyClsfCd === "PNT") {
                    console.log(searchParam);
                    callApi("POST", searchParam, "/web/api/dvc-mgt/edm/pnt-reset")
                        .then(res => {
                            alert("", t("alert.pntReset"), () => { getDvcList() });
                        })
                        .catch(error => {
                            alert("", t("alert.pntResetError"), () => { });
                        })
                } else {
                    callApi("POST", searchParam, "/web/api/dvc-mgt/edm/pnt-reset")
                        .then(res => {
                            alert("", t("alert.qtyReset"), () => { getDvcList() });
                        })
                        .catch(error => {
                            alert("", t("alert.qtyResetError"), () => { });
                        })
                }
            break;
            case "cmmnDeleteBtn":
                if (searchParam.frcgPtgyClsfCd === "PNT") {
                    callApi("POST", searchParam, "/web/api/dvc-mgt/edm/pnt-delete")
                        .then(res => {
                            alert("", t("m_alert.pntDelete"), () => { getDvcList() });
                        })
                        .catch(error => {
                            alert("", t("m_alert.pntDeleteError"), () => { });
                        })
                } else {
                    callApi("POST", searchParam, "/web/api/dvc-mgt/edm/pnt-delete")
                        .then(res => {
                            alert("", t("m_alert.qtyDelete"), () => { getDvcList() });
                        })
                        .catch(error => {
                            alert("", t("m_alert.qtyDeleteError"), () => { });
                        })
                }
                break;
            case "cmmnRestartBtn":
                let eqmt = `${controlDeviceClsfCd}`;
                let eqmtNm;
                let uri = "/web/api/mqtt/send/control-device-restart";
                let params = { eqmtNo: dvc.eqmtNo, controlDeviceClsfCd: controlDeviceClsfCd };
                let confirmText;

                if (eqmt === "PRGM") {
                    eqmtNm = t("m_deviceMgtPage.restartProgram");
                    confirmText = t("m_deviceMgtPage.programConfirm");
                } else if (eqmt === "COIND") {
                    eqmtNm = t("m_deviceMgtPage.restartPaymentDvc");
                    confirmText = t("m_deviceMgtPage.paymentDvcConfirm");
                } else if (eqmt === "CAMERA") {
                    eqmtNm = t("m_deviceMgtPage.restartCamera");
                    confirmText = t("m_deviceMgtPage.cameraConfirm");
                } else if (eqmt === "OFF") {
                    eqmt = "PRGM";
                    uri = "/web/api/mqtt/send/control-device";
                    eqmtNm = t("m_deviceMgtPage.programOff");
                    params = { eqmtNo: dvc.eqmtNo, controlDeviceClsfCd: "PRGM", cmdCd: "OFF" }
                    confirmText = t("m_deviceMgtPage.programOffConfirm");
                }
                modalConfirm("", confirmText, () => {
                    callApi("GET", params, uri)
                        .then(res => {
                            alert("", `${eqmtNm}`, () => { }, "", "common.closeLable");
                        })
                        .catch(error => {
                            alert("", `${t("m_alert.dvcRestartError")}`, () => { });
                        })
                })
                break;
            case "cmmnTestPrintBtn":
                
                const testPrintUrl = "/web/api/mqtt/send/test-print";
                const testPrintParams = { eqmtNo: dvc.eqmtNo, cmdCd: controlDeviceClsfCd };
                
                modalConfirm("", t("m_deviceMgtPage.testPrintConfirm"), () => {
                    callApi("GET", testPrintParams, testPrintUrl)
                        .then(res => {
                            alert("", t("m_alert.testPrintSuccess"), () => { }, "", "common.closeLable");
                        })
                        .catch(error => {
                            alert("", `${t("m_alert.dvcTestPrintError")}`, () => { });
                        })
                })
                break;
            default: break;
        }
    };

    return (
        <>
            <section id="dvcWrap">
                <div className="title-wrap">
                    <div className="title" style={{ background: "none" }}>
                        <img src={titleLogo} alt={t("m_deviceMgtPage.dvcMgt")} />
                        <h2>{t("m_deviceMgtPage.dvcMgt")}</h2>
                    </div>
                </div>
                {dvcList.map((dvc, idx) => (
                    <DvcBoxWrap key={idx}>
                        <div className={`dashboard-box ${idx > 0 ? 'mt-30' : ''}`}>
                            <MenuTitleWrap>
                                <h3>{dvc.eqmtNm}</h3>
                                <ButtonUtil className="btn btn-danger round-filled-small-btn small-btn w-10"
                                    value={t("m_deviceMgtPage.config")}
                                    onClick={() => { openMbSysModal(dvc) }}
                                />
                            </MenuTitleWrap>
                            <DeviceMtr>
                                {!dvc.isConnectionFailed ?
                                    <div className="device-img" style={{ backgroundImage: `url(${dvc.prgmCptrImgCn})` }}>
                                        <div className="device-status">
                                            <div className={`state-box ${dvc.prgmStatCd === "INUSE" ? "use" : "wating"}`}>
                                                {dvc.prgmStatCd === "INUSE" ? t("m_deviceMgtPage.inuse") : t("m_deviceMgtPage.waiting")}
                                            </div>
                                            <NetStatusImg netStatCd={dvc.netStatCd} />
                                        </div>
                                    </div>
                                    :
                                    !dvc.isReceivingScreen ?
                                    <div className="device-img" style={{ backgroundImage: `url(${receiveScreen})` }}>
                                        <div className="device-status">
                                            <div className={`state-box ${dvc.prgmStatCd === "INUSE" ? "use" : "wating"}`}>
                                                {dvc.prgmStatCd === "INUSE" ? t("m_deviceMgtPage.inuse") : t("m_deviceMgtPage.waiting")}
                                            </div>
                                            <NetStatusImg netStatCd={dvc.netStatCd} />
                                        </div>
                                    </div>
                                    :
                                    <div className="device-img" style={{ backgroundImage: `url(${connectFailImg})` }}>
                                        <div className="device-status">
                                            <div className={"state-box connect-fail"} >
                                                {dvc.isConnectionFailed && t("m_deviceMgtPage.connectFailed")}
                                            </div>
                                            <NetStatusImg netStatCd={dvc.netStatCd} />
                                        </div>
                                    </div>
                                }
                            </DeviceMtr>
                        </div>
                        <CustomAccordion>
                            <Accordion defaultActiveKey="0">
                                <CmmnAccordionItem eventKey="0" header={t("m_deviceMgtPage.controlDevice")}>
                                    <CmmnRestartIcon
                                        dataArray={controlArr}
                                        handleClick={(controlDeviceClsfCd) => handleCmmnBtnClick("cmmnRestartBtn", dvc, controlDeviceClsfCd)}
                                    />
                                </CmmnAccordionItem>
                                <CmmnAccordionItem eventKey="1" header={t("m_deviceMgtPage.dvcInfo")}>
                                    <InfoList>
                                        <li>
                                            <h2>{t("m_deviceMgtPage.prgmStat")}</h2>
                                            {!dvc.isConnectionFailed ?
                                                <h3>{dvc.prgmStatCd === "INUSE" ? t("m_deviceMgtPage.inuse") : t("m_deviceMgtPage.waiting")}</h3>
                                                :
                                                <h3>{dvc.isConnectionFailed && t("m_deviceMgtPage.connectFailed")}</h3>
                                            }
                                        </li>
                                        <li>
                                            <h2>{t("m_deviceMgtPage.prntStat")}</h2>
                                            <h3>{(dvc.prntStatMsgCn == null || dvc.prntStatMsgCn == undefined) ? "-" : dvc.prntStatMsgCn}</h3>
                                        </li>
                                        <li>
                                            <h2>{t("m_deviceMgtPage.remPapr")}</h2>
                                            <h3>{(dvc.remPaprQty == null || dvc.remPaprQty == undefined) ? 0 : dvc.remPaprQty}{t("m_deviceMgtPage.sheet")}</h3>
                                        </li>
                                        <li>
                                            <h2>{t("m_deviceMgtPage.pntAndFrcgPtgy")}</h2>
                                            <h3>
                                                {(dvc.slblPnt == null || dvc.slblPnt == undefined) ? '0' : dvc.slblPnt.toLocaleString()}P/
                                                {(dvc.slblFrcgPtgyQty == null || dvc.slblFrcgPtgyQty == undefined) ? '0' : dvc.slblFrcgPtgyQty.toLocaleString()}{t("m_deviceMgtPage.page")}
                                            </h3>
                                        </li>
                                    </InfoList>
                                </CmmnAccordionItem>
                                <CmmnAccordionItem eventKey="2" header={t("m_deviceMgtPage.pntAndFrcg")}>
                                    <CmmnRadio
                                        id={`frcgPtgyClsfCd${idx}`}
                                        dataArray={pointFreeArr}
                                        defaultVal={dvc.pntSelected}
                                        tagName={`frcgPtgyClsfCd${idx}`}
                                        onSelectChange={(e) => { handlePntDataChange(e, idx) }}
                                        isMobile={isMobile}
                                    />
                                    <PlusMinusBtnWrap>
                                        <ButtonUtil className="circle-icon-btn"
                                            onClick={() => { handleDecrease(idx) }}>
                                            <FontAwesomeIcon icon={faMinus} />
                                        </ButtonUtil>
                                        <div className="plus-minus-input">
                                            <InputBox
                                                type="text"
                                                id={`input${idx}`}
                                                name={`input${idx}`}
                                                className="input_box"
                                                value={dvc.pntSelected === "PNT" ? `${dvc.pnt}P` : `${dvc.qty}장`}
                                                disabled={true}
                                            />
                                        </div>
                                        <ButtonUtil className="circle-icon-btn"
                                            onClick={() => { handleIncrease(idx) }}>
                                            <FontAwesomeIcon icon={faPlus} />
                                        </ButtonUtil>
                                    </PlusMinusBtnWrap>
                                    <SmallBtnWrap>
                                        <ButtonUtil
                                            className="btn btn-danger round-filled-btn"
                                            value={t("m_deviceMgtPage.apply")}
                                            onClick={() => { handleCmmnBtnClick("cmmnInsertBtn", dvc) }}
                                            disabled={applyingDevices[dvc.eqmtId]}
                                        />
                                        <ButtonUtil
                                            className="btn btn-light round-filled-gray-btn bottom-modal-clos-btn"
                                            value={t("deviceMgtPage.reset")}
                                            onClick={() => { handleCmmnBtnClick("cmmnResetBtn", dvc) }}
                                            disabled={applyingResetDevices[dvc.eqmtId]}
                                        />
                                        {/* <ButtonUtil
                                        className="btn btn-light round-filled-gray-btn bottom-modal-close-btn"
                                        value={t("m_deviceMgtPage.clear")}
                                        onClick={() => { handleCmmnBtnClick("cmmnDeleteBtn", dvc) }}
                                    /> */}
                                    </SmallBtnWrap>
                                </CmmnAccordionItem>
                                <CmmnAccordionItem eventKey="3" header={t("m_deviceMgtPage.lblTestPrint")}>
                                    <CmmnTestPrintIcon
                                        dataArray={testPrintArr}
                                        handleClick={(controlDeviceClsfCd) => handleCmmnBtnClick("cmmnTestPrintBtn", dvc, controlDeviceClsfCd)}
                                    />
                                </CmmnAccordionItem>
                            </Accordion>
                        </CustomAccordion>
                    </DvcBoxWrap>
                ))}
            </section>
            <CmmnMbSysCnfModal
                show={sysModalOpen}
                data={sysModalData}
                onHide={closeMbSysModal}
                brchClsfCd={brchClsfCd}
                t={t}
            />
        </>
    )
}